export default "__VITE_ASSET__DF1mcBU___"